import { useMemo } from 'react';
import { TUserTypes } from 'src/constants/user.constants';
import { useGetIdentity } from 'src/hooks';
import { useSideNavItems } from 'src/utils';
import { useAppSelector } from 'src/store/hooks';

import { TNavigation } from './Navigation';

const useSideNavigationItems = () => {
  // Hooks
  const { getIdentities } = useGetIdentity();
  const SIDE_NAV_ITEMS = useSideNavItems();
  const { totalUnreadConversationCount } = useAppSelector(
    (store) => store.notifications
  );
  const { notificationCount, chatCount } = useAppSelector(
    (store) => store.chat
  );

  const { loggedInUserType }: { loggedInUserType: TUserTypes } = getIdentities();

  const sideNavItems = useMemo(() => {
    return SIDE_NAV_ITEMS.filter(
      (sideNavItem: TNavigation) =>
        sideNavItem.availableToUserType === loggedInUserType ||
        sideNavItem.availableToUserType === 'All'
    );
  }, [loggedInUserType, notificationCount, totalUnreadConversationCount, chatCount, SIDE_NAV_ITEMS]);

  return sideNavItems;
};

export default useSideNavigationItems;
